export type HapticPattern = number | number[];

interface VibratingNavigator {
  vibrate?: (pattern: HapticPattern) => boolean;
}

export function vibrate(
  pattern: HapticPattern,
  enabled: boolean,
  nav: VibratingNavigator | undefined = typeof navigator === "undefined" ? undefined : navigator
): boolean {
  if (!enabled || typeof nav?.vibrate !== "function") return false;
  return nav.vibrate(pattern);
}
